import { DUPE_API_URL } from '@dupe/common/constants'

/**
 * DUP-2853: `catalog-country-filter` as this browser resolved it, sent to the
 * API on every request so a cohort or percentage rollout reaches the server
 * with the same answer the picker got. The API falls back to its global gate
 * when the header is absent (flag not loaded yet, or a non-web caller).
 *
 * Module state rather than per-hook headers because `fetcher` is a plain
 * function every search hook already goes through. `useCatalogCountryFilter`
 * keeps it in sync; BrainChat, which uses its own `fetch`, adds the same value
 * to its headers memo.
 */
export const CATALOG_COUNTRY_FILTER_HEADER = 'x-catalog-country-filter'

let current: 'on' | 'off' | undefined

export function setCatalogCountryFilterHeader(enabled: boolean | undefined) {
  current = enabled === undefined ? undefined : enabled ? 'on' : 'off'
}

/** The header to merge into a request to `url`; empty for other hosts. */
export function catalogCountryFilterHeaders(
  url: string
): Record<string, string> {
  if (!current || !url.startsWith(DUPE_API_URL)) return {}
  return { [CATALOG_COUNTRY_FILTER_HEADER]: current }
}
